import { render } from "./ViewsErrors400.vue?vue&type=template&id=47e5094b"
import script from "./ViewsErrors400.vue?vue&type=script&lang=js"
export * from "./ViewsErrors400.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__